import { render } from "./buyAppuntamentoModal.vue?vue&type=template&id=762cc84f&ts=true"
import script from "./buyAppuntamentoModal.vue?vue&type=script&lang=ts"
export * from "./buyAppuntamentoModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__